import { render } from "./BookmarksView.vue?vue&type=template&id=30342223"
import script from "./BookmarksView.vue?vue&type=script&lang=js"
export * from "./BookmarksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__